<template>
  <div class="account_container paymentMb" v-loading="editCardLoading">
    <div class="main-content">
      <div class="card-edit-error" v-if="editCardFailure">
        <svg class="icon icon-error">
          <path
            d="M7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14zm-1.05-3.85A1.05 1.05 0 1 1 7 11.2a1.008 1.008 0 0 1-1.05-1.05zm.381-1.981l-.266-5.25h1.841l-.255 5.25h-1.32z"></path>
        </svg>
        <p>{{ editCardFailureMessage }}</p>
      </div>
      <transition name="modal" v-if="confirmPaymentChange">
        <div class="payment-modal-mask" @click="closeEditModal">
          <div class="modal-wrapper">
            <div class="payments-modal" @click.stop>
              <div>
                <p class="modalPayment-header">Are you sure you want to edit this payment method</p>
                <div class="button-payment-holder">
                  <button class="yes-btn" @click="postCard">Yes</button>
                  <button class="refuse" @click="closeEditModal">Cancel</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <transition name="modal" v-if="deleteCardActive">
        <div class="payment-modal-mask" @click="closeDeleteModal">
          <div class="modal-wrapper">
            <div class="payments-modal" @click.stop>
              <div>
                <p class="modalPayment-header">Are you sure you want to delete this payment method?</p>
                <div class="button-payment-holder">
                  <button class="yes-btn" @click="deletePaymentMethod">Yes</button>
                  <button class="refuse" @click="closeDeleteModal">No</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <transition name="scroll-down">
        <ul>
          <div v-if="savedCards.length > 0">
            <li class="payment-box" v-for="item in savedCards">
              <div class="name-container">
                <p class="payment-head">{{ item.cardType }} {{ item.cardNumber }}</p>
                <p class="default-pay" @click="triggerDelete(item)">{{ $t('delete') }}</p>
              </div>
              <p class="edit-pay" @click="triggerEdit(item)">{{ $t('change') }}</p>
            </li>
          </div>
        </ul>
      </transition>
      <div class="payment-add-container">
        <!-- <img v-if="!showAddPayment" src="../../assets/img/address-add.jpg" @click="togglePayment(true)" alt=""> -->
        <div class="hide-payment" v-if="showAddPayment" @click="togglePayment(false)">
          <p>-</p>
        </div>
      </div>
      <div v-if="savedCards.length===0 && !savedCardsLoading" class="continue-shopping">
        <p>{{ $t('no_payment_methods') }}</p>
        <button @click="continueShopping">{{ $t('continueShopping') }}</button>
      </div>
      <div v-if="savedCardsLoading" class="profile-loading">
        <svg version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
             x="0px" y="0px"
             width="120px" height="120px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;"
             xml:space="preserve">
          <path fill="#7cc26a"
                d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z">
            <animateTransform attributeType="xml"
                              attributeName="transform"
                              type="rotate"
                              from="0 25 25"
                              to="360 25 25"
                              dur="1s"
                              repeatCount="indefinite"
            />
          </path>
        </svg>
      </div>
      <transition name="scroll-up">
        <div class="payment-form" v-show="showAddPayment">
          <div class="address-line"></div>
          <p class="payment-form-header">Edit Payment Method</p>
          <div class="input-item">
            <p class="input-title">Name</p>
            <input class="input-box" v-model="cardInfo.Name" autocomplete="off"/>
            <span v-if="error.Name" class='error-message'>
              <svg class="icon icon-error">
                <path
                  d="M7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14zm-1.05-3.85A1.05 1.05 0 1 1 7 11.2a1.008 1.008 0 0 1-1.05-1.05zm.381-1.981l-.266-5.25h1.841l-.255 5.25h-1.32z"></path>
              </svg>
            {{ error.Name }}
          </span>
          </div>
          <div class="input-item">
            <p class="input-title">Card Number</p>
            <input
              class="input-box"
              v-model="cardInfo.CardNumber"
              @input="cardNumberFormatter(cardInfo.CardNumber)"
            />
            <span v-if="error.CardNumber" class='error-message'>
              <svg class="icon icon-error">
                <path
                  d="M7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14zm-1.05-3.85A1.05 1.05 0 1 1 7 11.2a1.008 1.008 0 0 1-1.05-1.05zm.381-1.981l-.266-5.25h1.841l-.255 5.25h-1.32z"></path>
              </svg>
            {{ error.CardNumber }}
          </span>
          </div>
          <div class="input-item-dual">
            <div class="input-itemcity">
              <p class="input-title">Expiration Date</p>
              <input
                class="input-box"
                v-model="cardInfo.ExpirationDate"
                @input="cardExpireDateFormatter(cardInfo.ExpirationDate)"

                placeholder="MM/YY"
              />
              <span v-if="error.ExpirationDate" class='error-message'>
                <svg class="icon icon-error">
                  <path
                    d="M7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14zm-1.05-3.85A1.05 1.05 0 1 1 7 11.2a1.008 1.008 0 0 1-1.05-1.05zm.381-1.981l-.266-5.25h1.841l-.255 5.25h-1.32z"></path>
                </svg>
              {{ error.ExpirationDate }}
            </span>
            </div>
            <div class="input-itemzip">
              <p class="input-title">CVV</p>
              <input
                class="input-box"
                v-model="cardInfo.CVV"

                autocomplete="off"
              />
            </div>
          </div>
          <div class="input-item">
            <p class="input-title">Address</p>
            <input
              v-model="cardInfo.Street"
              :placeholder="[(formHasErrors && !cardInfo.Street) ? 'Address Required*' : 'Enter Delivery Address']"
              :class="[(formHasErrors && !cardInfo.Street) ? 'input-box-error' : 'input-box']"
            />
            <span v-if="error.Street" class='error-message'>
                <svg class="icon icon-error">
                  <path
                    d="M7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14zm-1.05-3.85A1.05 1.05 0 1 1 7 11.2a1.008 1.008 0 0 1-1.05-1.05zm.381-1.981l-.266-5.25h1.841l-.255 5.25h-1.32z"></path>
                </svg>
              {{ error.Street }}
            </span>
          </div>
          <div class="input-item-tri">
            <div class="input-itemcity">
              <p class="input-title">City</p>
              <input
                v-model="cardInfo.City"
                :placeholder="[(formHasErrors && !cardInfo.City) ? 'City Required*' : 'Seattle']"
                :class="[(formHasErrors && !cardInfo.City) ? 'input-box-error' : 'input-box']"

              />
              <span v-if="error.City" class='error-message'>
                  <svg class="icon icon-error">
                    <path
                      d="M7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14zm-1.05-3.85A1.05 1.05 0 1 1 7 11.2a1.008 1.008 0 0 1-1.05-1.05zm.381-1.981l-.266-5.25h1.841l-.255 5.25h-1.32z"></path>
                  </svg>
                {{ error.City }}
              </span>
            </div>
            <div class="input-itemstate">
              <p class="input-title">State</p>
              <input v-model="cardInfo.State"
                     :placeholder="[(formHasErrors && !cardInfo.State) ? 'State Required*' : 'WA']"
                     :class="[(formHasErrors && !cardInfo.State) ? 'input-box-error' : 'input-box']"/>
              <span v-if="error.State" class='error-message'>
                  <svg class="icon icon-error">
                    <path
                      d="M7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14zm-1.05-3.85A1.05 1.05 0 1 1 7 11.2a1.008 1.008 0 0 1-1.05-1.05zm.381-1.981l-.266-5.25h1.841l-.255 5.25h-1.32z"></path>
                  </svg>
                {{ error.State }}
              </span>
            </div>
            <div class="input-itemzip">
              <p class="input-title">Zipcode</p>
              <input v-model="cardInfo.Zip" :placeholder="[(formHasErrors && !cardInfo.Zip) ? 'Zip*' : '98033']"
                     :class="[(formHasErrors && !cardInfo.Zip) ? 'input-box-error' : 'input-box']"/>
              <span v-if="error.Zip" class='error-message'>
                  <svg class="icon icon-error">
                    <path
                      d="M7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14zm-1.05-3.85A1.05 1.05 0 1 1 7 11.2a1.008 1.008 0 0 1-1.05-1.05zm.381-1.981l-.266-5.25h1.841l-.255 5.25h-1.32z"></path>
                  </svg>
                {{ error.Zip }}
              </span>
            </div>
          </div>
          <!-- <button class="payment-submit-button" v-if="editing" @click="togglePaymentConfirmModal" :disabled="formHasErrors">Sa</button> -->
          <button class="payment-submit-button" @click="togglePaymentConfirmModal" :disabled="formHasErrors">Save
          </button>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import {mapActions, mapState, mapMutations} from 'vuex';

export default {
  name: "payments",
  data() {
    return {
      showAddPayment: false,
      cardInfo: {
        Name: '',
        CardNumber: '',
        CVV: '',
        ExpirationDate: '',
        Street: '',
        City: '',
        State: '',
        Zip: '',
      },
      error: {
        Name: '',
        CardNumber: '',
        CVV: '',
        ExpirationDate: '',
        Street: '',
        City: '',
        State: '',
        Zip: '',
      },
      formHasErrors: false,
      editing: false,
      activeCard: '',
      activeCardDelete: '',
      confirmPaymentChange: false,
      deleteCardActive: false,
    }
  },
  methods: {
    ...mapActions('checkout', ['fetchAchProfiles', 'editACHProfile', 'deleteProfile', 'resetEditCardError']),
    fetchCards() {
      if (this.userDetails) {
        this.fetchAchProfiles([this.userDetails.Customer_id, this.warehouseLocation])
      }
    },
    continueShopping() {
      this.$router.push('/collections');
    },
    checkForm() {
      if (!this.cardInfo.Name) {
        this.error.Name = 'Name is required'
      } else {
        this.error.Name = '';
      }
      if (!this.cardInfo.CardNumber) {
        this.error.CardNumber = 'Card Number is required.'
      } else {
        this.error.CardNumber = '';
      }
      if (!this.cardInfo.ExpirationDate) {
        this.error.ExpirationDate = 'Expiration Date is required'
      } else {
        this.error.ExpirationDate = '';
      }
      if (!this.cardInfo.Street) {
        this.error.Street = 'Street is required'
      } else {
        this.error.Street = '';
      }
      if (!this.cardInfo.City) {
        this.error.City = 'City is required'
      } else {
        this.error.City = '';
      }
      if (!this.cardInfo.State) {
        this.error.State = 'State is required'
      } else if (this.cardInfo.State.length !== 2) {
        this.error.State = 'State must be a two letter initial.';
      } else {
        this.error.State = '';
      }
      if (!this.cardInfo.Zip) {
        this.error.Zip = 'Zipcode is required'
      } else {
        this.error.Zip = '';
      }
    },
    cardExpireDateFormatter(date) {
      if (date.length == 3) {
        if (date[date.length - 1] !== '/') {
          var temp = this.cardInfo.ExpirationDate.split('');
          temp.splice(2, 0, '/');
          this.cardInfo.ExpirationDate = temp.join('');
          return;
        } else {
          this.cardInfo.ExpirationDate = this.cardInfo.ExpirationDate.slice(0, 2);
        }
      }
    },
    postCard() {
      let paymentInfo = {};
      let cardNum = this.cardInfo.CardNumber.replace(/\s+/g, '');
      paymentInfo.first = this.cardInfo.Name.split(' ')[0];
      paymentInfo.last = this.cardInfo.Name.split(' ')[1];
      paymentInfo.card_number = cardNum;
      paymentInfo.exp_date = this.cardInfo.ExpirationDate;
      paymentInfo.street = this.cardInfo.Street;
      paymentInfo.city = this.cardInfo.City;
      paymentInfo.state = this.cardInfo.State;
      paymentInfo.zipcode = this.cardInfo.Zip;
      let data = [paymentInfo, this.activeCard];
      this.editACHProfile(data);
    },
    cardNumberFormatter(value) {
      var v = value.replace(/\s+/g, '').replace(/[^0-9]/gi, '')
      var matches = v.match(/\d{4,19}/g);
      var match = matches && matches[0] || ''
      var parts = []
      for (var i = 0, len = match.length; i < len; i += 4) {
        parts.push(match.substring(i, i + 4))
      }
      if (parts.length) {
        this.cardInfo.CardNumber = parts.join(' ')
      } else {
        this.cardInfo.CardNumber = value
      }
    },
    formatAchCard(value) {
      var parts = []
      for (var i = 0, len = value.length; i < len; i += 4) {
        parts.push(value.substring(i, i + 4))
      }
      if (parts.length) {
        this.cardInfo.CardNumber = parts.join(' ')
      } else {
        this.cardInfo.CardNumber = value
      }
    },
    deletePaymentMethod() {
      this.deleteProfile(this.activeCardDelete)
    },
    triggerEdit(card) {
      if (!this.formHasErrors) {
        this.showAddPayment = true;
        this.editing = true;
        this.activeCard = card.profileId;
        this.formatAchCard(card.cardNumber);
        this.cardInfo.ExpirationDate = card.expirationDate
        const addressInfo = card.billto || {}
        this.cardInfo.Street = addressInfo.address || ''
        this.cardInfo.City = addressInfo.city || ''
        this.cardInfo.Name = (addressInfo.firstName || '') + ' ' + (addressInfo.lastName || '')
        this.cardInfo.Zip = addressInfo.zip || ''
        this.cardInfo.State = addressInfo.state || ''
      }
    },
    triggerDelete(card) {
      this.deleteCardActive = true;
      this.activeCardDelete = card.profileId;
    },
    closeDeleteModal() {
      this.deleteCardActive = false;
      this.activeCardDelete = '';
    },
    closeEditModal() {
      this.showAddPayment = false;
      this.editing = false;
      this.activeCard = '';
      this.confirmPaymentChange = false;
    },
    togglePayment(value) {
      this.showAddPayment = value;
      this.editing = false;
      this.activeCard = '';
    },
    togglePaymentConfirmModal() {
      let errors = this.error;
      let valid = true;
      this.checkForm();
      for (var key in errors) {
        if (this.error[key] !== '') {
          valid = false;
        }
      }
      if (valid) {
        this.confirmPaymentChange = !this.confirmPaymentChange;
      }
    },
    clearForms() {
      this.error = {
        Name: '',
        CardNumber: '',
        CVV: '',
        ExpirationDate: '',
        Street: '',
        City: '',
        State: '',
        Zip: '',
      };
      this.cardInfo = {
        Name: '',
        CardNumber: '',
        CVV: '',
        ExpirationDate: '',
        Street: '',
        City: '',
        State: '',
        Zip: '',
      };
    }
  },
  mounted() {
    this.fetchCards();
  },
  computed: mapState({
    loggedIn: state => state.auth.loggedIn,
    userDetails: state => state.auth.userDetails,
    savedCardsError: state => state.checkout.savedCardsError,
    savedCards: state => state.checkout.savedCards,
    savedCardsLoading: state => state.checkout.savedCardsLoading,
    editCardSuccess: state => state.checkout.editCardSuccess,
    editCardLoading: state => state.checkout.editCardLoading,
    editCardFailure: state => state.checkout.editCardFailure,
    warehouseLocation: state => state.navbar.warehouseLocation,
    editCardFirstName() {
      return this.cardInfo.Name.split(' ')[0];
    },
    editCardLastName() {
      return this.cardInfo.Name.split(' ')[1];
    },
    editCardFailureMessage: state => state.checkout.editCardFailureMessage,
  }),
  watch: {
    editCardSuccess: function (newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.closeEditModal();
        this.closeDeleteModal();
        this.fetchCards();
        this.clearForms();
      }
    },
    editCardFailure: function (newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.closeEditModal();
        this.closeDeleteModal();
        this.clearForms();
      }
    }
  }
}
</script>
<style scoped lang="less">
@import "../../assets/css/profileorder.less";
@import "../../assets/css/modalNew.less";
</style>



// WEBPACK FOOTER //
// src/view/Profile/payment.vue